import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class FinancialDataValueType extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> Financial constructor -', init)
    if (isNil(init)) return undefined
    this._employee_id = init.employee_id
    this._initial_value = init.initial_value
    this._final_value = init.final_value
  }

  static shape = {
    id: PropTypes.string,
    employee_id: PropTypes.string.isRequired,
    initial_value: PropTypes.number,
    final_value: PropTypes.number
  }

  get employee_id() {
    return this._employee_id
  }

  get initial_value() {
    return this._initial_value
  }

  get final_value() {
    return this._final_value
  }
}

export default FinancialDataValueType
